import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { postConfigPtMonMedidor } from './services'
import { IPostConfigPtMonMedidor } from './types'

const initialState: any = {
  status: "",
  data: [],
  msgError: ""
}

export const actionPostConfigPtMonMedidor: any = createAsyncThunk<any, IPostConfigPtMonMedidor>(
  "ACTION_POST_CONFIG_PT_MON_MEDIDOR",
  async (data, { getState }: any) => {
    const {
      getLojas: { lojaSelected },
      modulosByCentral: {
        entradaSelected: {
          modulo: {
            idCentral,
            adrModulo,
            modelo,
          },
          entrada
        }
      },
      equipamentos: {
        dataUnidadeDeMedida
      }
    } = getState()

    return postConfigPtMonMedidor({
      ...data,
      idLoja: lojaSelected,
      idCentral,
      adrModulo,
      modeloModulo: modelo,
      idEntrada: entrada.id,
      unidadeMedida: dataUnidadeDeMedida.find(({unidade}) => unidade === data.unidadeMedida)?.unidade,
    });
  }
)

const slicePostConfigPtMonMedidor = createSlice({
  name: "POST_CONFIG",
  initialState,
  reducers: {
      actionResetStateConfigPtMonMedidor: (state) => {
      state.status = ""
      state.msgError = ""
    }
  },
  extraReducers: {
      [actionPostConfigPtMonMedidor.pending]: (state) => {
      state.status = "loading"
    },
      [actionPostConfigPtMonMedidor.fulfilled]: (state) => {
      state.status = "success"
    },
      [actionPostConfigPtMonMedidor.rejected]: (state, {error: { message }}) => {
      state.status = "error"
      state.msgError = message
    },
  }
})

export default slicePostConfigPtMonMedidor.reducer
export const { actionResetStateConfigPtMonMedidor } =
    slicePostConfigPtMonMedidor.actions;